import { ReactNode } from 'react'
import { useAuth } from '../../contexts/AuthProvider'
import { Alerta } from '../kit'

/**
 * Solo staff. La API igual responde 403 a quien no lo es: esto es para no mostrar
 * una pantalla que no va a funcionar, no la autorización.
 */
export default function RequireStaff({ children }: { children: ReactNode }) {
  const { user } = useAuth()
  if (!user?.es_staff) return <Alerta tipo="error" titulo="Sin acceso">Esta sección es solo para la administración de la aplicación.</Alerta>
  return <>{children}</>
}
